import styled from '@emotion/styled';

import Image from 'components/global/Image';

export const TitleContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	align-content: center;
	gap: 1rem;
`;

export const Logo = styled(Image)`
	border-radius: 4px;
	margin-right: var(--margin-3);
	body[dir='rtl'] & {
		margin-right: unset;
		margin-left: var(--margin-3);
	}
`;

export const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--padding-3);

	.accordion-content-container {
		line-height: 2rem;
	}
`;
